import { render, staticRenderFns } from "./StdSizeExtends.vue?vue&type=template&id=2b8f4946&scoped=true"
import script from "./StdSizeExtends.vue?vue&type=script&lang=js"
export * from "./StdSizeExtends.vue?vue&type=script&lang=js"
import style0 from "./StdSizeExtends.vue?vue&type=style&index=0&id=2b8f4946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f4946",
  null
  
)

export default component.exports